export default "__VITE_ASSET__DlQ0lhn$__"